import { createAction } from "redux-starter-kit";
import { APP_ISSUES_SET } from "../actionTypes";
import { getAnIssueApi } from "../../api/issues";

export const appSetIssueAction = createAction(APP_ISSUES_SET);

export function loadAnIssueRequestAction(issueID, isPdf, toast, history) {
  return async dispatch => {
    try {
      let anIssue = await getAnIssueApi(issueID, isPdf);
      dispatch(appSetIssueAction({ issue: anIssue }));
    } catch (e) {
      if (e.message === "404") {
        history.push(`${process.env.REACT_APP_URL_ROOT}404`);
      } else {
        toast.error(e.toString());
      }
    }
  };
}
